import instance from "..";

export const viewAllCircles = () =>
  instance.get("/api/backend/v1/circles/view?status=active");
